import { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { Controller } from "react-hook-form";

export default function DateField({ control, watch, errors, setValue }) {
  const [qoutDate, setQoutDate] = useState(new Date());

  useEffect(() => {
    const calculateValidUntil = () => {
      let date = new Date(qoutDate);
      date.setDate(date.getDate() + 90);
      setValue("validUntil", date);
    };

    calculateValidUntil();
  }, [qoutDate, setValue]);

  const validUntil = watch("validUntil", new Date(qoutDate).setDate(qoutDate.getDate() + 90));

  const calculateDaysBetween = (startDate, endDate) => {
    const oneDay = 24 * 60 * 60 * 1000; // hours * minutes * seconds * milliseconds
    return Math.round(Math.abs((startDate - endDate) / oneDay));
  };

  const daysBetween = calculateDaysBetween(qoutDate, validUntil);

  return (
    <div className="row">
      <div className="col-12 col-md-6">
        <p className="mb-1" style={{ fontWeight: 500 }}>
          Date
        </p>
        <Controller
          name="qoutDate"
          control={control}
          defaultValue={qoutDate}
          render={({ field }) => (
            <ReactDatePicker
              className="form-control"
              selected={field.value}
              onChange={(date) => {
                field.onChange(date);
                setQoutDate(date);
              }}
              dateFormat="MMMM dd, yyyy"
            />
          )}
        />
      </div>
      <div className="col-12 col-md-6">
        <p className="mb-1" style={{ fontWeight: 500 }}>
          Valid Until
        </p>
        <Controller
          name="validUntil"
          control={control}
          defaultValue={new Date(qoutDate).setDate(qoutDate.getDate() + 90)}
          render={({ field }) => (
            <ReactDatePicker
              className="form-control"
              selected={field.value}
              onChange={(date) => {
                field.onChange(date);
              }}
              dateFormat="MMMM dd, yyyy"
            />
          )}
        />
        <p style={{ fontWeight: 500, fontSize: `0.8rem` }} className="text-success">
          The quotation is valid for {daysBetween} days.
        </p>
      </div>
    </div>
  );
}
